import { styled } from '../jss-style';
import imageStyle from './image';

const useImageStyle = styled(imageStyle, 'image');

export { imageStyle, useImageStyle };
export default useImageStyle;
